module.exports = __webpack_public_path__ + "static/media/veneto-3-10.990ea745.jpg";